import React from 'react';
import { CheckIcon } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
import { sections } from '../data/sections';
import { boardRoles } from '../data/boardRoles';
const section = sections[1];
export function Experiences() {
  return <div data-id="element-171" data-mp="295o3hf9569ox">
      <PageHeader section={section} intro="Every Chair and Non-Executive Director appointment held, set out in full with the governance mandate and the impact delivered." data-id="element-172" data-mp="2d4wx8k46m7kh" />

      <ol className="mt-12 space-y-px border border-slate-200 bg-slate-200" data-id="element-173" data-mp="30wtyjha09h7c">
        {boardRoles.map(role => <li key={role.id} className="bg-white" data-id="element-174" data-mp="2s2fgj6y3bskj">
            <article className="grid gap-8 p-8 sm:p-10 lg:grid-cols-[0.8fr_1.2fr]" data-id="element-175" data-mp="2s1nvgq24dd8i">
              <div data-id="element-176" data-mp="2w2g71pygru7y">
                <span className={['inline-block border px-2.5 py-1 text-[10px] font-semibold uppercase tracking-widest', role.status === 'Current' ? 'border-gold/60 bg-gold/10 text-gold-dark' : 'border-slate-300 text-slateink-light'].join(' ')} data-id="element-177" data-mp="2w1y5qewy2pt6">
                  {role.status} appointment
                </span>
                <h2 className="mt-5 font-serif text-2xl leading-tight text-navy" data-id="element-178" data-mp="8logtcjwo9fm">
                  {role.organisation}
                </h2>
                <p className="mt-2 text-sm font-semibold text-slateink" data-id="element-179" data-mp="3tdgi8l96lmj">
                  {role.role}
                </p>
                <ul className="mt-6 flex flex-wrap gap-2" data-id="element-180" data-mp="hnxrc2f6c2t0">
                  {role.tags.map(tag => <li key={tag} className="whitespace-nowrap bg-bone px-3 py-1.5 text-[11px] font-medium text-slateink ring-1 ring-inset ring-slate-200" data-id="element-181" data-mp="rk93mserksng">
                      {tag}
                    </li>)}
                </ul>
              </div>

              <div className="border-l-2 border-gold/40 pl-7" data-id="element-182" data-mp="2odc92unz5ds3">
                <p className="text-[15px] leading-relaxed text-slateink" data-id="element-183" data-mp="s9ecgihk0g21">
                  {role.summary}
                </p>
                <h3 className="mt-7 text-[10px] font-semibold uppercase tracking-overline text-slateink-light" data-id="element-184" data-mp="x7plir00ymj7">
                  Governance impact
                </h3>
                <ul className="mt-4 space-y-3" data-id="element-185" data-mp="1695wazur4qny">
                  {role.impact.map(point => <li key={point} className="flex gap-3" data-id="element-186" data-mp="1b8a53pdrkmdr">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-dark" aria-hidden="true" data-id="element-187" data-mp="1b7qxp2lqpgdz" />
                      <span className="text-[14px] leading-relaxed text-slateink" data-id="element-188" data-mp="1kxtr33wrwwcu">
                        {point}
                      </span>
                    </li>)}
                </ul>
              </div>
            </article>
          </li>)}
      </ol>
    </div>;
}